/**
 * CSS columns 레이아웃으로 실제 컬럼 수를 측정합니다.
 * 측정과 표시가 동일한 레이아웃을 사용하여 잘림/빈 페이지를 최소화합니다.
 */
export const measureEpisodePageCount = (
  contentElement: HTMLElement,
  contentAreaHeight: number,
  viewportWidth: number
): number => {
  if (!contentElement || contentAreaHeight <= 0 || viewportWidth <= 0) return 1;

  const contentWidth = contentElement.scrollWidth;
  const columnCount = Math.ceil(contentWidth / viewportWidth);
  return Math.max(1, columnCount);
};
